module.exports = __webpack_public_path__ + "img/how-it-works-heads.655af8aa.webp";